import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M9.6665 16.6667C13.8086 16.6667 17.1665 13.3088 17.1665 9.16666C17.1665 5.02452 13.8086 1.66666 9.6665 1.66666C5.52437 1.66666 2.1665 5.02452 2.1665 9.16666C2.1665 13.3088 5.52437 16.6667 9.6665 16.6667Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M18.8332 18.3332L16.1519 15.6519"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search"}) } }